export default [
  {
    short: 'en',
    name: 'English',
    flag: '🇬🇧'
  },
  {
    short: 'ru',
    name: 'Русский',
    flag: '🇷🇺'
  }
]
